import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <section className="section-pad">
      <div className="container-page max-w-xl text-center">
        <div className="font-heading text-6xl font-bold text-primary">404</div>
        <h1 className="mt-4 font-heading text-3xl font-semibold text-slate-900">Page not found</h1>
        <p className="mt-3 text-slate-600">The link you followed may be broken or the page may have moved.</p>
        <Link to="/" className="mt-6 inline-block"><Button data-testid="nf-home">Go to home</Button></Link>
      </div>
    </section>
  );
}
